import React, { Component, Fragment } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import moment from 'moment';
import { animateScroll } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faUser } from '@fortawesome/free-regular-svg-icons';
import { FETCH_URL } from '../../constants/ServerLinks';

import './AtgChat.scss';

class AtgChat extends Component {
  constructor(props) {
    super(props);

    this.fetchURL = FETCH_URL;
    this.cookies = new Cookies();
    this.worldId = this.cookies.get('world_id');
    this.skey = this.cookies.get('world_skey');
    this.p_id = this.cookies.get('p_id');
    this.country_name = this.cookies.get('country_name');
  }

  scrollToBottom() {
    animateScroll.scrollToBottom({
      containerId: 'chatscroll',
    });
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  render() {
    const { messages } = this.props;
    return (
      <div>
        <div
          className={`atgChatBox`}
          style={
            !this.props.clicked ? { opacity: 0, visibility: 'hidden' } : null
          }
        >
          <div className={`atgChatBoxHeader`}>ATG Chat Box</div>
          <div id="chatscroll" className={`atgChatMessages`}>
            {messages.length > 0
              ? messages.map(
                  (item) =>
                    this.country_name !== item.sender_country ? (
                      <div
                        key={item.id}
                        className={`flex flex-items-center flex-wrap`}
                      >
                        <div className={`flex flex-column atgChatSender`}>
                          <span>{item.sender_country} </span>
                          <span style={{ color: 'green', fontSize: '1.2rem' }}>
                            {moment(item.created).fromNow()}
                          </span>
                        </div>
                        <div className={`atgChatMessageItem`}>
                          <p>{item.message}</p>
                        </div>
                      </div>
                    ) : (
                      <div
                        key={item.id}
                        className={`flex flex-items-center flex-justify-end flex-wrap`}
                      >
                        <div className={`atgChatMessageItemSender`}>
                          <p>{item.message}</p>
                        </div>
                        <div className={`flex flex-column atgChatSender`}>
                          <span>{item.sender_country} </span>
                          <span style={{ color: 'green', fontSize: '1.2rem' }}>
                            {moment(item.created).fromNow()}
                          </span>
                        </div>
                      </div>
                    )
                )
              : null}
          </div>
          <div className={`atgChatInputBox`}>
            <form>
              <input
                className={`atgChatInput`}
                type="text"
                name="senderMessage"
                value={this.props.senderMessage}
                placeholder="Write a reply..."
                onChange={(e) => this.props.handleChange(e)}
              />
              <button
                className={`atgChatSendButton`}
                onClick={this.props.sendMessage}
              >
                <span>
                  <FontAwesomeIcon icon={faPaperPlane} />
                </span>
              </button>
            </form>
          </div>
        </div>
        {this.props.messageCount > 0 && !this.props.clicked ? (
          <div className={`atgBadge`}>{this.props.messageCount}</div>
        ) : null}
        <div className={`atgButton`} onClick={this.props.showBox}>
          <span>ATG</span>
        </div>
      </div>
    );
  }
}

export default AtgChat;
